import React, { useEffect, useState } from "react";
import { Phone } from "lucide-react";
import BrandIcon from "@/components/BrandIcon";

const LINKS = [
  { id: "quote", label: "Quote", primary: true },
  { id: "portfolio", label: "Work" },
  { id: "services", label: "Services" },
  { id: "assistant", label: "AI Help" },
  { id: "faq", label: "FAQ" },
  { id: "contact", label: "Contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? "backdrop-blur-xl bg-black/70 border-b border-white/10"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <button
          data-testid="nav-logo"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="flex items-center gap-2.5 group"
        >
          <BrandIcon size={36} />
          <span className="font-display text-base font-semibold tracking-tight">
            3D PRINT HUB
            <span className="hidden sm:inline font-mono text-[10px] tracking-[0.3em] text-zinc-500 ml-2">
              BLR
            </span>
          </span>
        </button>

        <nav className="hidden md:flex items-center gap-1">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => scrollTo(l.id)}
              className={`text-sm font-medium px-3 h-9 rounded-full transition-all duration-200 ${
                l.primary
                  ? "text-[#FF5722] bg-[#FF5722]/10 hover:bg-[#FF5722]/20 border border-[#FF5722]/30"
                  : "text-zinc-400 hover:text-white hover:bg-white/5"
              }`}
            >
              {l.label}
            </button>
          ))}
        </nav>

        <a
          data-testid="nav-call-cta"
          href="tel:+918088163846"
          className="hidden sm:flex items-center gap-2 px-4 h-9 border border-white/15 hover:border-[#FF5722] hover:text-[#FF5722] text-xs font-mono tracking-wider transition-colors"
        >
          <Phone size={12} />
          +91 80881 63846
        </a>
      </div>
    </header>
  );
}
